import { fork, take } from 'redux-saga/effects'

import getConstants from '../../../constants'

import request from 'services/Request'

import * as actionTypes from '../actionTypes'
import * as api from '../api'

const CONSTANTS = getConstants()

export function* getStatesForRegionWorker() {
  const args: api.GetStatesForRegionProps = {
    country: CONSTANTS.COUNTRY,
  }

  yield request(
    actionTypes.STATES_FOR_REGION_REQUESTED,
    api.getAllStateList,
    args,
  )
}

export function* getAllStatesSaga() {
  while (true) {
    yield take(actionTypes.STATES_FOR_REGION_REQUESTED)
    yield fork(getStatesForRegionWorker)
  }
}

export default getAllStatesSaga
